module.exports = __webpack_public_path__ + "static/media/varejo-5.e4e73607.jpg";